$(function () {
    var $fixable_header = $("#fixable-header");

    if ($fixable_header.length === 0) {
        return;
    }

    var previous_pos = 0;
    var $win = $(window);
    var fixable_header_height = $fixable_header.height();

    $win.scroll(function () {

        var current_pos = $(this).scrollTop();

        if (current_pos < fixable_header_height) { // scroll top
            $fixable_header
                .removeClass('fixable-header--hidden')
            ;
        }
        else if (current_pos > previous_pos && current_pos > fixable_header_height) { // scroll down
            $fixable_header.addClass('fixable-header--hidden')
                .removeClass('fixable-header--fixed')
            ;
        } else { // scroll up
            $fixable_header.removeClass('fixable-header--hidden')
                .addClass('fixable-header--fixed')
            ;
        }

        previous_pos = current_pos;
    });
});